import SpacePath from "components/SpacePath";
import { ArrowDown, ArrowUp, Users } from "components/icons/generated";
import Box from "ds/components/Box";
import Tooltip from "ds/components/Tooltip";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsAccessGrantSource, SpaceDetailsAccessRoleBinding } from "./types";

const SpaceDetailsAccessGrantedViaCell = ({
  item: binding,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsAccessRoleBinding>) => {
  const { grantedVia } = binding;

  return (
    <TableSimpleCell {...cellProps}>
      {grantedVia.kind === "group" && (
        <TableCellLink
          variant="primary"
          startIcon={Users}
          tooltip="Granted via group"
          href={`/settings/idp-group/${grantedVia.id}`}
        >
          {grantedVia.name}
        </TableCellLink>
      )}

      {grantedVia.kind === "space" &&
        grantedVia.source === SpaceDetailsAccessGrantSource.PROPAGATED && (
          <SpacePath
            spaceId={grantedVia.id}
            fallbackName={grantedVia.name}
            icon={ArrowDown}
            tooltip="Inherited from parent space"
          />
        )}

      {grantedVia.kind === "space" &&
        grantedVia.source === SpaceDetailsAccessGrantSource.INHERITED && (
          <SpacePath
            spaceId={grantedVia.id}
            fallbackName={grantedVia.name}
            icon={ArrowUp}
            tooltip="Inherited from child space"
          />
        )}

      {grantedVia.kind === "space" &&
        grantedVia.source === SpaceDetailsAccessGrantSource.RESIDENT && (
          <Tooltip
            on={(props) => (
              <Box {...props}>
                <SpacePath
                  variant="static"
                  spaceId={grantedVia.id}
                  fallbackName={grantedVia.name}
                />
              </Box>
            )}
          >
            Current space
          </Tooltip>
        )}
    </TableSimpleCell>
  );
};

export default SpaceDetailsAccessGrantedViaCell;
